import Rect from "../../api/model/snapshots/layers/Rect";
import { isAlmostEqual } from "../math";

type RectDiffOptions = {
    ignorePos?: boolean;
    ignoreWidth?: boolean;
    ignoreHeight?: boolean;
};

function equals(rect: Rect, otherRect: Rect, options: RectDiffOptions = {}) {
    return (
        (options.ignorePos || isAlmostEqual(rect.x, otherRect.x)) &&
        (options.ignorePos || isAlmostEqual(rect.y, otherRect.y)) &&
        (options.ignoreWidth || isAlmostEqual(rect.width, otherRect.width)) &&
        (options.ignoreHeight || isAlmostEqual(rect.height, otherRect.height))
    );
}

// Line sweep algorithm to calculate total area of given rects, without counting overlaps multiple times
function calcTotalArea(rects: Rect[]): number {
    let totalArea = 0;
    let active: Array<{ start: number; end: number; }> = [];
    let events: Array<{ start: number; end: number; type: "open" | "close"; y: number; }> = [];

    if (!rects.length) {
        return 0;
    }

    for (const rect of rects) {
        events.push({ start: rect.x, end: rect.x + rect.width, type: "open", y: rect.y });
        events.push({ start: rect.x, end: rect.x + rect.width, type: "close", y: rect.y + rect.height });
    }
    events = events.sort((a, b) => a.y - b.y);

    let [{ y }] = events;
    for (const event of events) {
        const { y: currY, type, start, end } = event;
        let maxLength = 0;
        let curr = -1;
        for (const ev of active) {
            curr = Math.max(curr, ev.start);
            maxLength += Math.max(0, ev.end - curr);
            curr = Math.max(curr, ev.end);
        }
        totalArea += maxLength * (currY - y);
        if (type === "open") {
            active.push({ start, end });
            active = active.sort((a, b) => a.start - b.start);
        } else {
            for (let i = 0; i < active.length; i++) {
                const e = active[i];
                if (e.start === start && e.end === end) {
                    active.splice(i, 1);
                    break;
                }
            }
        }
        y = currY;
    }
    return totalArea;
}

export { equals, calcTotalArea, RectDiffOptions };
